module.exports = __webpack_public_path__ + "img/laboratorio2_16-9_960.567221f2.jpg";